/*
  This example requires Tailwind CSS v2.0+

  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import React from "react";
import Footer from "../../footer/Footer";
import HeaderNoLoginCheck from "../../header/HeaderNoLoginCheck";
import {useAuth0} from "@auth0/auth0-react";

export default function SignupMobile() {

    const {loginWithRedirect} = useAuth0();

    return (
        <>
            <HeaderNoLoginCheck/>
            {/*<div className="min-h-full flex flex-col justify-center sm:px-6 lg:px-8">*/}
            {/*    <div className="sm:mx-auto sm:w-full sm:max-w-md">*/}
            {/*        <h2 className="mt-2 text-center text-3xl tracking-tight font-bold text-gray-900">Welcome To*/}
            {/*            VirtualTipz</h2>*/}
            {/*    </div>*/}

            {/*    <div className="mt-4 sm:mx-auto sm:w-full sm:max-w-md">*/}
            {/*        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">*/}
            {/*            <div className="space-y-6">*/}
            {/*                <div>*/}
            {/*                    <button*/}
            {/*                        className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-pink-500 hover:bg-pink-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-800"*/}
            {/*                        onClick={() => {*/}
            {/*                            loginWithRedirect();*/}
            {/*                        }}*/}
            {/*                    >*/}
            {/*                        Login*/}
            {/*                    </button>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <div className="bg-white dark:bg-gray-900">
                <div className="px-6 py-24 sm:px-6 sm:py-32 lg:px-8">
                    <div className="mx-auto max-w-2xl text-center">
                        <h2 className="text-balance text-4xl font-semibold tracking-tight text-gray-900 dark:text-gray-100 sm:text-5xl">
                            Signup for VirtualTipz
                        </h2>
                        <p className="mx-auto mt-6 max-w-xl text-pretty text-lg/8 text-gray-600 dark:text-gray-400">
                            Incididunt sint fugiat pariatur cupidatat consectetur sit cillum anim id veniam aliqua
                            proident excepteur
                            commodo do ea.
                        </p>
                        <div className="mt-10 flex items-center justify-center gap-x-6">
                            <button
                                onClick={() => {
                                    loginWithRedirect({
                                        authorizationParams: {
                                            screen_hint: "signup"
                                        }
                                    })
                                }}
                                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-pink-500 hover:bg-pink-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-800"
                            >
                                Sign Up
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    )
}
